import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
};

export const consumedCreditText: SxStyleFunc<{
  isLow?: boolean;
  isEmpty?: boolean;
}> = ({ isLow, isEmpty }) => ({
  fontWeight: (p) => p.typography.fontWeightBold,
  lineHeight: 1,
  color: (p) =>
    isEmpty
      ? p.palette.error[600]
      : isLow
      ? p.palette.warning[600]
      : p.palette.grey[700],
});

export const totalCreditText: SxStyle = {
  color: (p) =>
    p.palette.mode === 'light' ? p.palette.grey[700] : p.palette.grey[500],
};
